document.addEventListener("DOMContentLoaded", function () {
  // Tự động di chuyển tất cả modal ra <body> ngay khi load trang
  function initModals() {
    document.querySelectorAll(".product-accordion-modal").forEach((modal) => {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  initModals();

  const getHeaders = () =>
    document.querySelectorAll("sticky-header, .shopify-section-group-header-group, .section-header, .header-wrapper, header");

  document.addEventListener("click", function (event) {
    // Khi click nút mở modal
    const opener = event.target.closest("[data-modal]");
    if (opener) {
      const targetSelector = opener.getAttribute("data-modal");
      if (targetSelector && targetSelector.startsWith("#")) {
        const modal = document.querySelector(targetSelector);
        if (modal) {
          if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
          }
          modal.style.display = "flex";
          modal.style.zIndex = "2147483647";
          document.body.classList.add("modal-open");

          getHeaders().forEach((h) => {
            h.style.setProperty("z-index", "1", "important");
          });
        }
      }
    }

    // Khi click nút đóng modal (dấu X)
    const closeBtn = event.target.closest(".product-accordion-modal__close-button");
    if (closeBtn) {
      const modal = closeBtn.closest(".product-accordion-modal");
      if (modal) {
        closeModal(modal);
      }
    }

    // Khi click nền tối (overlay) bên ngoài modal content
    if (
      event.target.classList.contains("product-accordion-modal") ||
      event.target.classList.contains("product-accordion-modal__overlay")
    ) {
      const modal = event.target.closest(".product-accordion-modal") || event.target;
      closeModal(modal);
    }
  });

  function closeModal(modal) {
    if (modal) {
      modal.style.display = "none";
      document.body.classList.remove("modal-open");
      getHeaders().forEach((h) => {
        h.style.removeProperty("z-index");
      });
    }
  }

  // Tự động điều chỉnh vị trí Live chat trên mobile để không đè lên nút Add to bag
  function adjustLiveChatPosition() {
    if (window.innerWidth > 768) return;
    const selectors = [
      '#ShopifyChat',
      '#dummy-chat-button-iframe',
      'iframe[name="shopify-chat-button-iframe"]',
      'iframe[id="ShopifyChat"]',
      '#shopify-chat-container',
      '#shopify-chat-button',
      '.ShopifyChat-button',
      'shopify-chat',
      'div[id^="shopify-chat"]',
      '#gorgias-chat-container',
      '#gorgias-web-messenger-container',
      'iframe#gorgias-web-messenger-container',
      '#gorgias-chat-wrapper',
      'div[id^="gorgias-chat"]',
      'div[id^="gorgias-"]',
      'iframe[title*="Chat"]',
      'iframe[title*="chat"]'
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.style.setProperty('bottom', 'calc(75px + env(safe-area-inset-bottom, 0px))', 'important');
      });
    });
  }

  adjustLiveChatPosition();
  const chatObserver = new MutationObserver(adjustLiveChatPosition);
  chatObserver.observe(document.body, { childList: true, subtree: true });
  window.addEventListener("resize", adjustLiveChatPosition);
});

